export default __webpack_public_path__ + "92b6bb5f3dd2f3c35d9e71681497f284.svg";